module.exports = __webpack_public_path__ + "img/book-sparkles.45ef2191.svg";